import {
  GET_CATALOG,
  GET_CATALOG_SUCCESS,
  GET_CATALOG_FAIL,
  DELETE_CATALOG,
  DELETE_CATALOG_SUCCESS,
  DELETE_CATALOG_FAIL,
  UPDATE_CATALOG,
  UPDATE_CATALOG_SUCCESS,
  UPDATE_CATALOG_FAIL,
  ADD_NEW_CATALOG,
  ADD_CATALOG_SUCCESS,
  ADD_CATALOG_FAIL,
  CATALOG_LOADING,
  CATALOG_RESET,
  CATALOG_RESET_CREATE,
  GET_CATALOG_ONE,
  GET_CATALOG_AVAILABLE_ONE
} from "./actionType";

export const resetCatalogState = (actionType) => ({
  type: CATALOG_RESET,
  payload: { actionType },
});


export const resetCatalogCreateState = (actionType) => ({
  type: CATALOG_RESET_CREATE,
  payload: { actionType }
});

export const getCatalogSuccess = (actionType, data) => ({
  type: GET_CATALOG_SUCCESS,
  payload: { actionType, data },
});

export const getCatalogFail = (actionType, error) => ({
  type: GET_CATALOG_FAIL,
  payload: { actionType, error },
});

export const getCatalog = data => ({
  type: GET_CATALOG,
  payload: data,
});

export const getCatalogOne = (data) => ({
  type: GET_CATALOG_ONE,
  payload: data,
});

export const getCatalogAvailableOne = (data) => ({
  type: GET_CATALOG_AVAILABLE_ONE,
  payload: data,
});


export const getCatalogLoading = () => ({
  type: CATALOG_LOADING
});

export const deleteCatalog = data => ({
  type: DELETE_CATALOG,
  payload: data,
});

export const deleteCatalogSuccess = data => ({
  type: DELETE_CATALOG_SUCCESS,
  payload: data,
});

export const deleteCatalogFail = error => ({
  type: DELETE_CATALOG_FAIL,
  payload: error,
});

export const updateCatalog = data => ({
  type: UPDATE_CATALOG,
  payload: data,
});

export const updateCatalogFail = error => ({
  type: UPDATE_CATALOG_FAIL,
  payload: error,
});

export const updateCatalogSuccess = data => ({
  type: UPDATE_CATALOG_SUCCESS,
  payload: data,
});

export const addNewCatalog = data => ({
  type: ADD_NEW_CATALOG,
  payload: data,
});

export const addCatalogSuccess = data => ({
  type: ADD_CATALOG_SUCCESS,
  payload: data,
});

export const addCatalogFail = error => ({
  type: ADD_CATALOG_FAIL,
  payload: error,
});